import type { BatchRejectResponse, BatchRejectBody } from "@/core/types/(api)/cosignature";
import { cosignatureRequestsTyped } from "@/api/(requests)/cosignatureTyped";

export async function batchRejectAction(body: BatchRejectBody): Promise<BatchRejectResponse> {
  return cosignatureRequestsTyped.batch_reject({ body });
}
